import React, { useState } from "react";
import { ROUTE } from "../../route/Route";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useHistory } from "react-router-dom";
import { alreadyInCart } from "../../constant/utils";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const BookButton = (props: any) => {
  const { t } = useTranslation();
  const { type, data } = props;
  const history = useHistory();
  const [hvr, setHvr] = useState<any>(false);
  const bookingData: any = useSelector((state: any) => (state.checkout.bookingData ? state.checkout.bookingData : {}));
  const handleCheckout = (e: any) => {
    e.preventDefault();
    const already = alreadyInCart(type, type == "test" ? data?.TestCode : data?.PackageCode);
    if (!already) {
      if (data?.SellingPrice === 0) {
        toast.error("Home collection is not available for this, please change your location");
      } else if (
        bookingData?.selectedMember?.gender &&
        data?.Gender != "both" && 
        data?.Gender &&
        bookingData?.selectedMember?.gender?.toUpperCase() == data?.Gender?.toUpperCase()
      ) {
        toast.error(`You can not add this test, this test only for ${data?.Gender}`);
      } else if (data?.SellingPrice !== 0) {
        history.push(ROUTE.CHECKOUT, { type: type, data: data });
      }
    }
  };
  return (
    <a
      href={"#"}
      onClick={(e: any) => handleCheckout(e)}
      className="button--hexagon booknow"
      onMouseLeave={(e: any) => setHvr(false)}
      onMouseEnter={(e: any) => setHvr(true)}
    >
      <span>
        {" "}
        <img src={!hvr ? "/assets/img/calendar.png" : "/assets/img/calendar2.png"} className="scale_booknow" />
        {t("book_now")}
        <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
      </span>
    </a>
  );
};

export default BookButton;
